export default "__VITE_ASSET__dd2a6fae__"